module.exports = __webpack_public_path__ + "img/header-weddingRingsMillgrif@2x.f141a4e.jpg";